module.exports = __webpack_public_path__ + "img/green_131.5cc91ee8.png";